import * as Yup from 'yup';
import {
  firstNameValidation,
  middleNameValidation,
  lastNameValidation,
  suffixValidation,
} from 'components/FormFields/PII';
import nameFormModel from './formModel';

const {
  groupId,
  formFields: { first, middle, last, suffix },
} = nameFormModel;

const nameFormValidationSchema = Yup.object().shape({
  [groupId]: Yup.object().shape({
    [first.name]: firstNameValidation,
    [middle.name]: middleNameValidation.notRequired(),
    [last.name]: lastNameValidation,
    [suffix.name]: suffixValidation,
  }),
});

export default nameFormValidationSchema;
